import { render, staticRenderFns } from "./priceListTemplateEditor.vue?vue&type=template&id=3cb9b213&"
import script from "./priceListTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./priceListTemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports